import PropTypes from 'prop-types'
import React, { useState} from 'react'
import { useDrop } from '../contexts/DropContext'
import {FaPencilAlt} from "react-icons/fa"



const EditNoteButton = ({notes, sessionID, color, loadStatus }) => {
  const [buttonState, changeButtonState] = useState(true)
  const buttonClick = () => {
    changeButtonState(updateStatus())    
  }

  const project = useDrop().currentDrop

  const updateStatus = async () => {
    console.log("Notes: " + notes + " sessionID: " + sessionID)
    const res = await fetch('https://us-central1-openscopedataback.cloudfunctions.net/app/api/table/' + project + "/" + sessionID + "/notes" ,{
        method: 'POST',
        body: notes
    })
    const res2 =  await fetch('https://us-central1-openscopedataback.cloudfunctions.net/app/api/table/status/' + project
                              + '/' + sessionID)
    const data = await res2.json()
    console.log(data)
    loadStatus(notes)
    return data
  }
 
  return (
    <button
      onClick={buttonClick}
      style={{ backgroundColor: color}}
      variant="contained"
      className='btn'
    >
      <FaPencilAlt/>
    </button>
  )
}


EditNoteButton.defaultProps = {
  color: 'steelblue',
  sessionID: 837360280,
}

EditNoteButton.propTypes = { 
  sessionID: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
}

export default EditNoteButton